/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-progress-bar[_ngcontent-%COMP%]{width:100%;height:4px;text-align:center}"];
export { styles as styles };
